<!-- 放款详情 -->
<template>
  <div class='loan-record-detail pad-side20'>
    <div class="row flex justify-content-between align-items-center">
      <p>申请产品</p>
      <p class="grey-text">{{loanRecordDetail.productName || ''}}</p>
    </div>
    <div class="row flex justify-content-between align-items-center">
      <p>身份证号</p>
      <p class="grey-text">{{userInfo.idNo || ''}}</p>
    </div>
    <div class="row flex justify-content-between align-items-center">
      <p>申请金额</p>
      <p class="grey-text">{{loanRecordDetail.loanAmount || ''}}</p>
    </div>
    <div class="row flex justify-content-between align-items-center">
      <p>核准金额</p>
      <p class="grey-text">{{loanRecordDetail.creditAmount || ''}}</p>
    </div>
    <div class="row flex justify-content-between align-items-center">
      <p>动用金额</p>
      <p class="grey-text">{{loanRecordDetail.hadUsedAmount || ''}}</p>
    </div>
     <div class="row flex justify-content-between align-items-center">
      <p>银行卡号</p>
      <p class="grey-text">{{loanRecordDetail.debitCardNo || ''}}</p>
    </div>
     <div class="row flex justify-content-between align-items-center">
      <p>开户银行</p>
      <p class="grey-text">{{loanRecordDetail.decardOpenBank || ''}}</p>
    </div>
     <!-- <div class="row flex justify-content-between align-items-center">
      <p>贷款期数</p>
      <p class="grey-text">18期</p>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'LoanRecordDdetail',

  components: {},

  data () {
    return {
    };
  },

  computed: {
    ...mapState(['loanRecordDetail', 'userInfo'])
  },

  created() {},

  methods: {},
}

</script>

<style lang='less' scoped>
  .loan-record-detail {
    padding-top: 20px;
  }
  .row {
    padding: 12px 20px;
    border: 1px solid rgba(236,236,236,1);
  }
  .row:nth-of-type(2n) {
    background-color: #F6F6F6;
  }
  .grey-text {
    color: #BEBEBE;
  }
</style>